
export const ClientsAPI = {

  selectAll() {
    return $cfg.API.post('/admin/clients/select/all');
  },

  create(data) {
    return $cfg.API.post('/admin/clients', data);
  },

  update(client_id, data) {
    return $cfg.API.put('/admin/clients/' + client_id, data);
  },

  setIsPaid(client_id, flag) {
    return $cfg.API.put(`/admin/clients/${client_id}/billing/paid`, { flag });
  },

  remove(client_id) {
    return $cfg.API.delete('/admin/clients/' + client_id);
  },

  syncBillingThisMonth() {
    return $cfg.API.post('/admin/clients/sync');
  },

  generateInvoice(monthly_bill_id) {
    return $cfg.API.post(`/admin/clients/monthly-bill/${monthly_bill_id}/invoice/generate`);
  },

  sendInvoice(monthly_bill_id) {
    return $cfg.API.post(`/admin/clients/monthly-bill/${monthly_bill_id}/invoice/send`);
  },
}
